import { Text } from '../../../components/UI-CHAKRA/Text';
import { Flex } from '../../../components/UI-CHAKRA/Flex';
import { Box } from '../../../components/UI-CHAKRA/Box';
import React, { ChangeEvent } from 'react';
import { FormControl } from '../../../components/UI-CHAKRA/FormControl';
import { FormLabel } from '../../../components/UI-CHAKRA/FormLabel';
import SearchAddressByCep from '../../../components/SearchAddressByCep';
import { Input } from '../../../components/UI-CHAKRA/Input/Input';
import { Checkbox } from '../../../components/UI-CHAKRA/Checkbox';
import SelectState from '../../../components/SelectState';
import { useFormikContext } from 'formik';
import { EmissionProviderForm } from '../../../providers/EmissionProvider';
import { Address } from '../../../shared/cep';
import { MaskedInput, MASKS } from '../../../components/UI-CHAKRA/Input/MaskedInput';

export function EstablishmentAddressForm() {
  const form = useFormikContext<EmissionProviderForm>();
  const values = form.values;

  const onChangeFederationUnit = (value: string) => {
    form.setFieldValue('establishmentFederalUnit', value);
  };

  const handleChangeHouseWithoutNumber = (event: ChangeEvent<HTMLInputElement>) => {
    form.setFieldValue('establishmentHouseWithoutNumber', event.target.checked);
  };

  const onChangeCep = (value: string) => {
    form.setFieldValue('establishmentPostalCode', value);
  };

  const onFindAddress = (address: Address) => {
    form.setFieldValue('establishmentCity', address.localidade, false);
    form.setFieldValue('establishmentNeighborhood', address.bairro, false);
    form.setFieldValue('establishmentFederalUnit', address.uf, false);
    form.setFieldValue('establishmentAddress', address.logradouro, false);
  };

  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    form.validateField(event.target.name);
  };

  return (
    <Box>
      <Text fontSize={'16px'} fontWeight={'600'}>
        Informações faltantes do estabelecimento
      </Text>

      <Box>
        <Flex flexDir={{ base: 'column', md: 'row' }}>
          <Flex w={{ base: '100%', md: '50%' }} gap={'10px'} mt={'10px'} mr={'10px'}>
            <Box w={'30%'}>
              <SearchAddressByCep
                initialValue={values.establishmentPostalCode}
                onFindAddress={onFindAddress}
                onChange={onChangeCep}
                error={!!form.errors.establishmentPostalCode}
                size={'medium'}
                required
                fullWidth
                onBlur={() => form.validateField('establishmentPostalCode')}
              />
            </Box>

            <FormControl isInvalid={!!form.errors.establishmentAddress} w={'70%'}>
              <FormLabel>Endereço*</FormLabel>
              <Input
                w={'100%'}
                value={form.values.establishmentAddress}
                name={'establishmentAddress'}
                onChange={form.handleChange}
                placeholder={'Endereço'}
                onBlur={handleBlur}
              />
            </FormControl>
          </Flex>

          <Flex w={{ base: '100%', md: '50%' }} flexDir={'column'}>
            <Flex w={'100%'} gap={'10px'} mt={'10px'}>
              <FormControl isInvalid={!!form.errors.establishmentNumber} w={'30%'}>
                <FormLabel>Número*</FormLabel>

                <MaskedInput
                  mask={MASKS.NUMBER_FIVE_DIGITS}
                  maskChar={''}
                  w={'100%'}
                  value={values.establishmentNumber}
                  name={'establishmentNumber'}
                  onChange={form.handleChange}
                  placeholder={'Número'}
                  isDisabled={values.establishmentHouseWithoutNumber}
                  onBlur={handleBlur}
                />
              </FormControl>

              <FormControl w={'70%'}>
                <FormLabel>Complemento</FormLabel>
                <Input
                  w={'100%'}
                  placeholder={'Complemento'}
                  name={'establishmentComplement'}
                  value={values.establishmentComplement}
                  onChange={form.handleChange}
                  onBlur={handleBlur}
                />
              </FormControl>
            </Flex>

            <Flex mt={'6px'}>
              <FormControl>
                <Checkbox
                  size={'sm'}
                  isChecked={values.establishmentHouseWithoutNumber}
                  onChange={handleChangeHouseWithoutNumber}
                >
                  Sem Número
                </Checkbox>
              </FormControl>
            </Flex>
          </Flex>
        </Flex>

        <Flex mt={'10px'} gap={'10px'} direction={{ base: 'column', md: 'row' }}>
          <Flex gap={'10px'} w={'100%'}>
            <FormControl isInvalid={!!form.errors.establishmentNeighborhood} w={'50%'}>
              <FormLabel>Bairro*</FormLabel>
              <Input
                w={'100%'}
                name="establishmentNeighborhood"
                value={values.establishmentNeighborhood}
                onChange={form.handleChange}
                placeholder={'Bairro'}
                onBlur={handleBlur}
              />
            </FormControl>

            <FormControl isInvalid={!!form.errors.establishmentCity} w={'50%'}>
              <FormLabel>Cidade*</FormLabel>
              <Input
                w={'100%'}
                value={values.establishmentCity}
                name={'establishmentCity'}
                onChange={form.handleChange}
                placeholder={'Cidade'}
                onBlur={handleBlur}
              />
            </FormControl>
          </Flex>

          <Flex w={'100%'}>
            <FormControl isInvalid={!!form.errors.establishmentFederalUnit} w={'100%'}>
              <SelectState
                onChange={onChangeFederationUnit}
                value={values.establishmentFederalUnit}
                error={!!form.errors.establishmentFederalUnit}
                required
                onBlur={() => form.validateField('establishmentFederalUnit')}
              />
            </FormControl>
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
}
